import createReducer from '../../utils/createReducer';

const initialState = {
  locale: 'en',
  messages: {}
};

export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./src/universal/redux/modules/intl.js